import $ from 'jquery'

// Affichage de formulaire
function toogleFormWithRadioButton(id_1, id_2, form_1, form_2) {
  const radioButtonIdOne = document.getElementById(id_1)
  const radioButtonIdTwo = document.getElementById(id_2)

  radioButtonIdTwo.addEventListener('change', _event => {
    const FormOne = document.getElementById(form_1)
    const FormTwo = document.getElementById(form_2)
    FormOne.classList.add('d-none')
    FormTwo.classList.remove('d-none')
  })

  radioButtonIdOne.addEventListener('change', _event => {
    const FormOne = document.getElementById(form_1)
    const FormTwo = document.getElementById(form_2)
    FormOne.classList.remove('d-none')
    FormTwo.classList.add('d-none')
  })
}

function toogleOnlyFormWithRadioButton(id_1, id_2, form_1, form_2) {
  const radioButtonIdOne = document.getElementById(id_1)
  const radioButtonIdTwo = document.getElementById(id_2)
  const FormOne = document.getElementById(form_1)
  const FormTwo = document.getElementById(form_2)

  radioButtonIdTwo.addEventListener('change', _event => {
    FormOne.classList.add('d-none')
    FormTwo.classList.remove('d-none')
  })

  radioButtonIdOne.addEventListener('change', _event => {
    FormOne.classList.remove('d-none')
    FormTwo.classList.add('d-none')
  })
}

// Hide dropdown if "-" is selected (NB: need to check length = 1)
function hideHyphenDropdown(dropdown) {
  const dropdownDiv = dropdown.parentNode.parentNode
  if (dropdown.selectedOptions[0].innerHTML == '-') {
    dropdownDiv.classList.add('d-none')
  }
}

// Affiche la div du dropdown
function displayDropdownParentDiv(dropdown) {
  dropdown.parentNode.parentNode.classList.remove('d-none')
}

// AJAX call
function ajaxCall(url, data) {
  var result = ''
  console.log(url)
  $.ajax({
    url: url,
    async: false,
    dataType: 'json',
    type: 'POST',
    headers: {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
    },
    data: data,
    //   processData : false, LAURENT - ajouté pour eviter pbl serialization
    success: function (response) {
      console.log('ajax Call')
      console.log(response)
      result = response
    }
  })
  return result
}

// Suppression des elements dans la liste
function removeOptions(selectElement) {
  // console.log("fonction remove")
  var i,
    L = selectElement.options.length - 1
  for (i = L; i >= 0; i--) {
    selectElement.remove(i)
  }
}

// Ajout des éléments dans la liste
function addOptions(optionsArray, dropdown, placeholder) {
  // Ajout 1ère option blank
  const blank_option = document.createElement('option')
  blank_option.value = ''
  blank_option.innerHTML = placeholder
  dropdown.appendChild(blank_option)

  // Ajout des options
  optionsArray.forEach(function (item) {
    const new_option = document.createElement('option')
    new_option.value = item
    new_option.innerHTML = item
    dropdown.appendChild(new_option)
  })
}

// Ajout de la seule option disponible dans la listse
function addOnlyOption(dropdown, onlyOption) {
  removeOptions(dropdown)
  const new_option = document.createElement('option')
  new_option.value = typeof onlyOption === 'string' ? onlyOption : onlyOption[1]
  new_option.innerHTML = typeof onlyOption === 'string' ? onlyOption : onlyOption[0]
  dropdown.appendChild(new_option)
}

// Pour edit: selectionne la valeur Localization_1 sur le dropdown
function editSelectLocalizationOneValue() {
  console.log('editSelectLocalizationOneValue')
  const valueLocalizationOne = document
    .querySelector('#localization-1')
    .innerHTML.replace(/(^\s*(?!.+)\n+)|(\n+\s+(?!.+)$)/g, '')
    .trim()
  const dropdownLocalizationOne = document.querySelector('#activity_datum_localization_1')
  dropdownLocalizationOne.value = valueLocalizationOne
}

// Pour edit: selectionne la valeur data_unit_1 sur le dropdown
function editSelectUnitOneValue() {
  console.log('editSelectUnitOneValue')
  const valueUnitOne = document
    .querySelector('#unit-1')
    .innerHTML.replace(/(^\s*(?!.+)\n+)|(\n+\s+(?!.+)$)/g, '')
    .trim()
  const dropdownUnitOne = document.querySelector('#activity_datum_data_unit_1')
  dropdownUnitOne.value = valueUnitOne
  console.log(valueUnitOne)
}

export {
  addOnlyOption,
  addOptions,
  removeOptions,
  ajaxCall,
  hideHyphenDropdown,
  displayDropdownParentDiv,
  editSelectLocalizationOneValue,
  editSelectUnitOneValue,
  toogleFormWithRadioButton,
  toogleOnlyFormWithRadioButton
}
